import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import UneditableInput from "../../components/UneditableInput";
import AdditionalInformation from "../../components/AdditionalInformation";

import { getSendsBySearch } from "../../services/send";
import { getIssues } from "../../services/issue";
import { getChannels } from "../../services/channel";

import { showAlert } from "../../store/ducks/alert";

import { CircularProgress } from "@material-ui/core";

const SendInformation = (props) => {
  const dispatch = useDispatch();
  const [send, setSend] = useState({});
  const [sendIssue, setSendIssue] = useState({});
  const [sendChannel, setSendChannel] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    displayPayment();
  }, []);

  const displayPayment = async () => {
    const sendId = props.match.params.id;

    try {
      setIsLoading(true);

      const { data } = await getSendsBySearch("id", sendId);
      const {data: issue} = await getIssues(0, {searchItem :"id", search: data.rows[0].issueId});
      const { data: channelData } = await getChannels(0, {searchItem :"id", search: data.rows[0].channelId});
      setSend(data.rows[0]);
      setSendIssue(issue.rows);
      setSendChannel(channelData.rows);

      setIsLoading(false);
    } catch (error) {
      dispatch(showAlert("error", "Ops! We could not load. 😔"));
      console.log(error);
    }
  };

  const uneditable = Object.keys(send);

  if (isLoading)
    return <CircularProgress color="inherit" className="circular-progress" />;

  return (
    <>
      <div className="page-header">
        <h1>Send Information</h1>
      </div>
      <section className="update-section">
        <h3>View Send Properties</h3>
        <form className="update-form">
          <div className="form-fields">
            <UneditableInput data={send} labels={uneditable} />
          </div>
        </form>
      </section>
      {sendChannel[0] && (
        <section className="additional-section">
          <h3>Issue</h3>
          <AdditionalInformation
            data={sendIssue}
            dataKey="subject"
            path="issues"
          />
          <h3>Channel</h3>
          <AdditionalInformation
            data={sendChannel}
            dataKey="name"
            useUid={true}
            path="channels"
          />
        </section>
      )}
    </>
  );
};

export default SendInformation;
